import Component from './ManageWines';

export default Component;
